import { DEFAULT_REASON, EvidentlyFeatureExperiment } from '../../constants/evidently';
import { EVENT_NAMES } from '../../constants/mixpanel';
import { TrackEvidentlyMetricsParams } from '../../sdk/CommonSDK';
import { mixpanelTrackEvent } from '../mixpanel/common';

export type PasswordlessFeatureMetricKeys = 'Successful-Verifications';
export type OnboardingMandatoryV2FieldsVariations = 'Control' | 'Passwordless';

export const passwordlessFeatureName = 'PasswordlessLogin';
export const passwordlessVariant = 'Passwordless';

/**
 * This is only used in batchEvaluation
 *
 * @param profile Profile
 * @returns boolean
 */
const handleIsFeatureEvaluate = (): boolean => {
  return true;
};

const handleFeatureCallback = async (
  details: EvidentlyFeatureExperiment,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isAccountIsMixpanelEligableEnabled?: boolean
): Promise<void> => {
  if (details.reason === DEFAULT_REASON && !details.userId) {
    return;
  }

  mixpanelTrackEvent({
    eventName: EVENT_NAMES.EXPERIMENT_STARTED,
    payload: {
      eventProperties: {
        'Experiment name': 'New Passwordless Accounts',
        'Variant name': `${details.variation ?? 'Control'}`,
      },
    },
  });
};

const featureMetrics = (
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  details: EvidentlyFeatureExperiment
): TrackEvidentlyMetricsParams<PasswordlessFeatureMetricKeys>[] => {
  return [];
};

export const passwordlessEvaluation = [
  {
    featureMetrics,
    featureName: passwordlessFeatureName,
    featureCallback: handleFeatureCallback,
    featureHandleEvaluate: handleIsFeatureEvaluate,
  },
];
